import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import MuiDialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';

const DialogContent = withStyles(theme => ({
	root: {
		padding: theme.spacing(2),
	},
}))(MuiDialogContent);

export default function PaymentInfoDialog({
	royalPayPayment,
	stripePaymentId,
}) {
	const [open, setOpen] = React.useState(false);

	const handleClickOpen = () => {
		setOpen(true);
	};
	const handleClose = () => {
		setOpen(false);
	};

	const stripePayInfo = () => (
		<>
			<Typography variant='h3' gutterBottom>
				Stripe 支付
			</Typography>
			<Typography gutterBottom>
				您的订单是客户用银行卡通过 Stripe 支付的，支付ID是 :
			</Typography>
			<Typography gutterBottom>
				<a
					target='_blank'
					rel='noopener noreferrer'
					href={`https://dashboard.stripe.com/payments/${stripePaymentId}`}
				>
					{stripePaymentId}
				</a>
			</Typography>
			<Typography gutterBottom>请点击ID跳转到Stripe查看详情</Typography>
		</>
	);
	const royalpayInfo = () => (
		<>
			<Typography gutterBottom>您的订单是客户用Royal Pay支付的:</Typography>
			<Typography gutterBottom>
				Royal Pay 支付Id: {royalPayPayment.royal_pay_order_id}
			</Typography>
			<Typography gutterBottom>付款时间: {royalPayPayment.pay_time}</Typography>
			<Typography gutterBottom>币种: {royalPayPayment.currency}</Typography>
			<Typography gutterBottom>汇率: {royalPayPayment.rate}</Typography>
			<Typography gutterBottom>方式: {royalPayPayment.channel}</Typography>
			<Typography gutterBottom>
				总金额: {royalPayPayment.total_fee / 100}
			</Typography>
		</>
	);

	return (
		<div>
			<Button variant='outlined' color='primary' onClick={handleClickOpen}>
				付款信息
			</Button>

			<Dialog
				onClose={handleClose}
				aria-labelledby='customized-dialog-title'
				open={open}
			>
				<DialogContent dividers>
					{royalPayPayment && royalpayInfo()}
					{stripePaymentId && stripePayInfo()}
				</DialogContent>
			</Dialog>
		</div>
	);
}
